import React from 'react';
import { Box, Button, Typography, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { ChevronRight } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: '24px',
      paddingLeft: '24px',
      paddingTop: '16px',
      paddingBottom: '16px',
      border: '1px solid #54545440',
      borderRadius: '4px',
      justifyContent: 'space-between',
      cursor: 'default',
      backgroundColor: theme.color.white.neutral50,
      flex: 1,
    },
    taskContainer: {
      '& .title': {
        fontSize: '24px',
        fontWeight: 800,
        color: theme.color.grey.neutral400,
      },
      '& .description': {
        fontWeight: 400,
        color: theme.color.grey.neutral400,
        fontSize: '0.9rem',
      },
      '& .badge': {
        fontSize: '0.75rem',
        fontWeight: 550,
        padding: 8,
        paddingLeft: 12,
        paddingRight: 12,
        borderRadius: 4,
        backgroundColor: '#D9D9D9',
        color: theme.color.grey.neutral400,
      },
      '& .badgeContainer': {
        display: 'flex',
        marginTop: '8px',
        gap: '8px',
      },
    },
    button: {
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 'unset',
      width: '36px',
      color: 'white',
      backgroundColor: '#9E9E9E',
    },
  })
);

export interface OnboardingOptionTaskProps {
  title: string;
}

export const OnboardingOptionTask: React.FC<OnboardingOptionTaskProps> = ({ title }) => {
  const classes = useStyles();
  const { theme } = useCampfireTheme();

  return (
    <Box className={classes.container}>
      <Box className={classes.taskContainer}>
        <Box style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '8px' }}>
          <Box style={{ flexShrink: 0 }}>
            <Typography
              variant={'h6'}
              style={{ color: theme.color.grey.neutral400, fontWeight: 700, letterSpacing: '-0.02em' }}
            >
              {title}
            </Typography>
            <Typography
              style={{
                fontSize: '12px',
                lineHeight: 1,
                marginTop: '-2px',
                color: theme.color.grey.neutral400,
                fontWeight: 400,
              }}
            >
              Managed in Admin Console › Onboarding
            </Typography>
          </Box>
        </Box>
        <Box className={'badgeContainer'} style={{ gap: 9 }}>
          <Box
            className='badge'
            style={{
              backgroundColor: '#E3F2FD',
              color: '#1565C0',
              fontWeight: 600,
            }}
          >
            User Preference
          </Box>
        </Box>
      </Box>
      <Button disabled className={classes.button}>
        <ChevronRight />
      </Button>
    </Box>
  );
};
